import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";

import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";

import {
  clearCouponFilter,
  selectCouponFilter,
  setCouponSearchFilter,
  setCouponStatusFilter,
} from "../../../store/couponFilterSlice";

import classes from "./couponFilterPage.module.css";

const couponStatusOptions = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Active" },
  { id: "1", label: "Inactive" },
];

export const CouponFilterPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const { status, search } = useSelector(selectCouponFilter);

  /* ------------- Sync URL → Redux on load / when URL changes ------------- */
  useEffect(() => {
    const searchParam = searchParams.get("search");
    const statusParam = searchParams.get("status");

    if (!searchParam && !statusParam) {
      dispatch(clearCouponFilter());
      return;
    }

    dispatch(setCouponSearchFilter(searchParam ?? null));
    dispatch(setCouponStatusFilter(statusParam ?? null));
  }, [searchParams, dispatch]);

  /* ------------- Update URL + Redux together ------------- */
  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);

      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "search") dispatch(setCouponSearchFilter(value || null));
      if (key === "status") dispatch(setCouponStatusFilter(value || null));
    },
    [dispatch, searchParams, setSearchParams]
  );

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <h1 className={classes.box__content__title}>Coupons</h1>
      </div>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search || ""}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      <div className={classes.box__content__dropdown}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={couponStatusOptions}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>

      <div className={classes.box__content}>
        <Link to="/coupons/create" className={classes.box__btn}>
          Create Coupon
        </Link>
      </div>
    </div>
  );
};
